import { useState, useId } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LuChevronDown } from 'react-icons/lu';
import { cx } from '../../../design-system/components/cx';

interface FAQItemProps {
  question: string;
  answer: string;
}

/** One question in the FAQ Card: a disclosure button and its answer panel. */
export default function FAQItem({ question, answer }: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();

  return (
    <div className="ee-landing-faq__item">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="ee-landing-faq__q"
        aria-expanded={isOpen}
        aria-controls={panelId}
      >
        <span>{question}</span>
        <LuChevronDown
          className={cx('ee-landing-faq__chevron', isOpen && 'ee-landing-faq__chevron--open')}
          aria-hidden="true"
          focusable="false"
        />
      </button>
      <AnimatePresence>
        {isOpen ? (
          <motion.div
            id={panelId}
            role="region"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="ee-landing-faq__panel"
          >
            <p className="ee-landing-faq__a">{answer}</p>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
